import initApplication from "./src/apps/full";

if (window['isDOMLoaded'] === true) {
    initApplication();
} else {
    document.addEventListener('DOMContentLoaded', () => {
        initApplication();
    });
}
